export const AUTH_MODES = {
  KEYCLOAK: 'keycloak',
  FAKE_JWT: 'fake-jwt',
  SIMULATED: 'simulated',
};
